var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.linkProps)?_c('a',_vm._b({},'a',_vm.linkProps,false),[_vm._t("default")],2):(_vm.routerProps)?_c('RouterLink',_vm._b({},'RouterLink',_vm.routerProps,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }